import { UserRoleSchema, type UserRole as GeneratedUserRole } from '~/services/api/generated'

// Mirrors backend App\Enums\UserRole

export type UserRole = GeneratedUserRole

export const UserRole = {
  SUPER_ADMIN: UserRoleSchema.enum.super_admin,
  ADMIN: UserRoleSchema.enum.admin,
  ACCOUNT_OWNER: UserRoleSchema.enum.account_owner,
  PARTNER_MANAGER: UserRoleSchema.enum.partner_manager,
  STORE_MANAGER: UserRoleSchema.enum.store_manager,
  CUSTOMER: UserRoleSchema.enum.customer
} satisfies Record<string, GeneratedUserRole>

export const UserRoleValues: readonly GeneratedUserRole[] = [
  UserRoleSchema.enum.super_admin,
  UserRoleSchema.enum.admin,
  UserRoleSchema.enum.account_owner,
  UserRoleSchema.enum.partner_manager,
  UserRoleSchema.enum.store_manager,
  UserRoleSchema.enum.customer
]
